import { useEffect, useState } from "react"
import { useSnackbar } from "../../context/snackbar"
import CreateList from "./List/CreateList"
import ListCard from "./List/ListCard"

function ListTab() {
  const API = `${process.env.REACT_APP_API_URL}/api/lists`

  const [lists, setLists] = useState([])
  const [loading, setLoading] = useState(true)
  const [refresh, setRefresh] = useState(true)

  const { showSnackbar } = useSnackbar()

  /* =========================
     FETCH LISTS
  ========================= */
  useEffect(() => {
    const getLists = async () => {
      try {
        const res = await fetch(API, {
          credentials: "include",
        })

        const data = await res.json()

        if (res.ok) {
          setLists(Array.isArray(data) ? data : [])
        } else {
          showSnackbar(data.message || "Failed to fetch lists", "error")
        }
      } catch (err) {
        console.error("Fetch lists error:", err)
        showSnackbar("Something went wrong", "error")
      } finally {
        setLoading(false)
        setRefresh(false)
      }
    }

    if (refresh) getLists()
  }, [refresh, API, showSnackbar])

  /* =========================
     LOADING STATE
  ========================= */
  if (loading) return <h3>Loading...</h3>

  return (
    <div className="col-12 d-flex flex-column align-items-center">
      <h3 className="display-4">Lists</h3>

      {/* CREATE LIST MODAL */}
      <CreateList setRefresh={setRefresh} />

      {/* OPEN CREATE MODAL */}
      <button
        className="btn btn-primary my-3"
        data-bs-toggle="modal"
        data-bs-target="#createListModal"
      >
        + Create List
      </button>

      {/* LIST EMPTY STATE */}
      {lists.length === 0 && <p className="text-muted">No lists yet</p>}

      {/* LISTS */}
      {lists.map((l) => (
        <ListCard key={l._id} list={l} />
      ))}
    </div>
  )
}

export default ListTab
